// extracted by mini-css-extract-plugin
module.exports = {"BeeSpinner":"beeSpinner_BeeSpinner__3mJrX","progressAnimation":"beeSpinner_progressAnimation__2Jx8P"};